export default function DroitAcces(store) {
  return store.getters["user/payant"];
}
